import { format, parse } from "date-fns";
import { isArray } from "lodash";
import { NavigateFunction } from "react-router";

type Parser<T> = {
  appliable: (v: any) => boolean;
  serialize: (v: T) => string;
  deserialize: (v: string) => T
}

export function persistParams(navigate: NavigateFunction, payload: Record<string, any>) {
  const parsers = prepareParsers();
  const urlParams = new URLSearchParams();

  for (const key of Object.keys(payload)) {
    const value = payload[key];
    if (value === undefined || value === null || value === "") {
      delete payload[key];
      continue;
    }
    if (isArray(value)) {
      value.forEach((el) => {
        urlParams.append(key, serializeParam(el, parsers));
      });
    } else {
      urlParams.set(key, serializeParam(value, parsers));
    }
  }
  const target = urlParams.toString();
  navigate(`?${target}`, { replace: true });
}

function prepareParsers(): Parser<any>[] {
  return [dateParser()];
}

function serializeParam(v: any, parsers: Parser<any>[]) {
  for (const parser of parsers) {
    if (parser.appliable(v)) {
      return parser.serialize(v);
    }
  }
  return v.toString();
}

function dateParser(): Parser<Date> {
  return {
    appliable: (v) => v instanceof Date,
    serialize: (v) => format(v, "yyyyMMdd"),
    deserialize: (str) => parse(str, "yyyyMMdd", new Date())
  };
}
type Mapper<T> = (sp: URLSearchParams) => T
export function restorePayloadFromParams<
  Mappers extends readonly Mapper<any>[]
>(
  sp: URLSearchParams,
  mappers: Mappers
): { [K in keyof Mappers]: Mappers[K] extends Mapper<infer R> ? R : never } {
  return mappers.map((fn) => fn(sp)) as any;
}
